import { Box, Typography } from '@mui/material'

interface PromptBoxDropZoneOverlayProps {
  isMultiline?: boolean
}

export default function PromptBoxDropZoneOverlay({ isMultiline }: PromptBoxDropZoneOverlayProps) {
  return (
    <Box className="drop-zone-overlay">
      <Box
        sx={{
          border: t => (isMultiline ? `8px dashed ${t.palette.global.lightGray}` : undefined),
          borderRadius: '8px',
          height: '100%',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: t => t.palette.global.lightGray,
        }}
      >
        <Typography variant={isMultiline ? 'h1' : 'h3'}>Drop files here</Typography>
      </Box>
    </Box>
  )
}
